import { call, put, takeEvery } from 'redux-saga/effects';
import { mockStudents } from '../../../../utils/mockData';
import * as actions from './_actions';
import * as types from './_actionTypes';

function* fetchEligibleStudentsSaga() {
  try {
    // Filter students who have completed the course (progress >= 80%)
    const eligibleStudents = mockStudents
      .filter(student => student.progress >= 80)
      .map(student => ({
        ...student,
        finalScore: Math.floor(Math.random() * 20) + 70, // 70-90%
        completedAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
        certificateStatus: 'eligible'
      }));
    
    yield put(actions.fetchEligibleStudentsSuccess(eligibleStudents));
  } catch (error) {
    yield put(actions.fetchEligibleStudentsFailure(error.message));
  }
}

function* fetchCertificateRequestsSaga() {
  try {
    const mockRequests = [
      {
        id: 1,
        course: 'Computer Science Fundamentals',
        studentsCount: 45,
        requestedAt: '2024-01-20T10:00:00Z',
        status: 'approved',
        approvedAt: '2024-01-21T14:30:00Z',
        certificatesGenerated: 45
      },
      {
        id: 2,
        course: 'Advanced Mathematics',
        studentsCount: 38,
        requestedAt: '2024-01-18T15:30:00Z',
        status: 'pending',
        approvedAt: null,
        certificatesGenerated: 0
      }
    ];
    
    yield put(actions.fetchCertificateRequestsSuccess(mockRequests));
  } catch (error) {
    yield put(actions.fetchCertificateRequestsFailure(error.message));
  }
}

function* requestCertificatesSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 1500));
    
    const newRequest = {
      id: Date.now(),
      ...action.payload,
      requestedAt: new Date().toISOString(),
      status: 'pending',
      approvedAt: null,
      certificatesGenerated: 0
    };
    
    yield put(actions.requestCertificatesSuccess(newRequest));
  } catch (error) {
    yield put(actions.requestCertificatesFailure(error.message));
  }
}

function* downloadCertificatesSaga(action) {
  try {
    yield new Promise(resolve => setTimeout(resolve, 2000));
    
    const downloadData = {
      requestId: action.payload,
      downloadUrl: `/certificates/batch-${action.payload}.zip`,
      generatedAt: new Date().toISOString()
    };
    
    // Simulate download
    const link = document.createElement('a');
    link.href = downloadData.downloadUrl;
    link.download = `certificates-batch-${action.payload}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    yield put(actions.downloadCertificatesSuccess(downloadData));
  } catch (error) {
    yield put(actions.downloadCertificatesFailure(error.message));
  }
}

function* collegeCertificatePublishingSaga() {
  yield takeEvery(types.FETCH_ELIGIBLE_STUDENTS_REQUEST, fetchEligibleStudentsSaga);
  yield takeEvery(types.FETCH_CERTIFICATE_REQUESTS_REQUEST, fetchCertificateRequestsSaga);
  yield takeEvery(types.REQUEST_CERTIFICATES_REQUEST, requestCertificatesSaga);
  yield takeEvery(types.DOWNLOAD_CERTIFICATES_REQUEST, downloadCertificatesSaga);
}

export default collegeCertificatePublishingSaga;